import { render } from "./Conformance.vue?vue&type=template&id=3c5f32d8&scoped=true"
import script from "./Conformance.vue?vue&type=script&lang=js"
export * from "./Conformance.vue?vue&type=script&lang=js"

import "./Conformance.vue?vue&type=style&index=0&id=3c5f32d8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5f32d8"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
